export default [
  { id: 1, 작업내용: '석재 및 타일공사',
    유해위험요인: '타일 하역 중 지게차와 주변 근로자 충돌',
    개선대책: '1. 타일자재 하역장소에 신호수를 배치하여 주변 근로자 \n    통제',
  },
  { id: 2, 작업내용: '석재 및 타일공사',
    유해위험요인: '자재 하역 중 자재가 균형을 잃어 지게차 전도',
    개선대책: '1. 자재 하역장소를 사전 점검하여 평탄한 장소에서 \n    하역실시',
  },
  { id: 3, 작업내용: '석재 및 타일공사',
    유해위험요인: '비계 작업발판 위를 이동 중, 작업발판 파단에 의한 추락',
    개선대책: '1. 외부비계 위에 작업발판 설치시 작업 도중에 파단되지 \n    않도록 견고한 것 설치',
  },
  { id: 4, 작업내용: '석재 및 타일공사',
    유해위험요인: '절단용 전동공구 사용시 감전',
    개선대책: '1. 절단용 공구에 접지 및 누전차단기 연결',
  },
  { id: 5, 작업내용: '석재 및 타일공사',
    유해위험요인: '타일붙임 작업 중 말비계에서 추락',
    개선대책: '1. 말비계는 작업발판 폭을 40cm 이상\n' +
      '2. 평탄한 바닥에서 균형을 유지하는지 확인',
  },
  { id: 6, 작업내용: '석재 및 타일공사',
    유해위험요인: '타일붙임 작업 중 주변 개구부로 추락',
    개선대책: '1. 타일붙임 장소를 사전 점검하여 개구부 등 추락 \n    위험장소에 방호조치',
  },
  { id: 7, 작업내용: '석재 및 타일공사',
    유해위험요인: '핸드그라인더로 면처리 작업 중 누전에 의한 감전',
    개선대책: '1. 핸드그라인더 등 기계기구 사전 점검, 접지 및 \n    누전차단기 연결',
  },
  { id: 8, 작업내용: '석재 및 타일공사',
    유해위험요인: '이동식 비계에서 줄눈작업을 위해 승하강 중 \n    실족하여 추락',
    개선대책: '1. 이동식 비계에는 승강사다리를 설치하여 추락재해 예방',
  },
  { id: 9, 작업내용: '석재 및 타일공사',
    유해위험요인: '줄눈시공시 타일면 위에서 넘어짐',
    개선대책: '1. 타일줄눈 시공 시 미끄럼 방지 조치 및 주변 정리정돈',
  },
  { id: 10, 작업내용: '석재 및 타일공사',
    유해위험요인: '안전모, 안전화를 미착용하고 줄눈·코킹 작업 중 \n    부딪히거나 낙하물에 맞음',
    개선대책: '1. 줄눈·코킹 작업시 안전모, 안전화의 철저한 착용',
  },
]
